import List from './LectureList'

const exportObj = {
    List
}

export default exportObj